import { render } from "./figthEncounter.vue?vue&type=template&id=202c3857&scoped=true"
import script from "./figthEncounter.vue?vue&type=script&lang=js"
export * from "./figthEncounter.vue?vue&type=script&lang=js"

import "./figthEncounter.vue?vue&type=style&index=0&id=202c3857&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c3857"]])

export default __exports__